/* eslint-disable arrow-parens */

export default objError => {
  let errorMsg = '';

  if (objError) {
    switch (objError) {
      case 'MDP107':
        errorMsg = 'errServerNoRecordFound';
        break;
      case 'MDP301':
        errorMsg = 'errFileNameDoesNotExists';
        break;
      case 'MDP304':
        errorMsg = 'errPermissionDenied';
        break;
      case 'MDP403':
        errorMsg = 'errAccessCodeNotValid';
        break;
      case 'MDP404':
        errorMsg = 'errAccessCodeExpired';
        break;
      case 'MDP405':
        errorMsg = 'errAccessCodeConsumed';
        break;
      case 'MDP457':
        errorMsg = 'errAccessCodeExpiredCard';
        break;
      case 'MDP458':
        errorMsg = 'errAccessCodeNotValidCard';
        break;
      case 'MDP459':
        errorMsg = 'errAccessCodeConsumedCard';
        break;
      default:
        errorMsg = 'errGeneralMessage';
        break;
    }
  } else if (objError.message) {
    switch (objError.message) {
      case 'No_Record_Found':
        errorMsg = 'errServerNoRecordFound';
        break;
      case 'Unable_Update_Card':
        errorMsg = 'errServerUnableUpdateCard';
        break;
      case 'Username_Exist':
        errorMsg = 'errServerUsernameExist';
        break;
      case 'Invalid_Credentials':
        errorMsg = 'errServerInvalidCredentials';
        break;
      case 'Locked_Out':
        errorMsg = 'errValPinMisMatError';
        break;
      case 'Authorization_Denied':
        errorMsg = 'errServerAuthorizationDenied';
        break;
      case 'Page_Not_Found':
        errorMsg = 'errServerPageNotFound';
        break;
      case 'Internal_Error':
        errorMsg = 'errServerInternalError';
        break;
      case 'Unable_Update_MemberAccess':
        errorMsg = 'errUpdateMemberAccess';
        break;
      case 'AccessCode_Not_Valid':
        errorMsg = 'errSharedOTPNotValid';
        break;
      case 'AccessCode_Expired':
        errorMsg = 'errSharedOTPExpired';
        break;
      case 'AccessCode_Consumed':
        errorMsg = 'errSharedOTPConsumed';
        break;
      case 'No_File_Available':
        errorMsg = 'errFileNotAvailable';
        break;
      default:
        errorMsg = 'errGeneralMessage';
        break;
    }
  } else {
    errorMsg = 'errGeneralMessage';
  }
  return errorMsg;
};
